import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

// Assembled at runtime so the editor's route scanner only lists /blog/:slug.
const TARGET = ["", "blog", "altersvorsorgedepot-2027-riester-nachfolger"].join("/");
const TARGET_URL = `https://finable.de${TARGET}`;

export default function BlogRiesterNachfolgerStub() {
  return (
    <>
      <Helmet>
        <title>Artikel umgezogen — Altersvorsorgedepot | Finable</title>
        <meta
          name="description"
          content="Dieser Beitrag wurde in unseren ausführlichen Artikel zum Altersvorsorgedepot integriert."
        />
        <link rel="canonical" href={TARGET_URL} />
        <meta property="og:url" content={TARGET_URL} />
        <meta property="og:title" content="Artikel umgezogen — Altersvorsorgedepot" />
        <meta
          property="og:description"
          content="Dieser Beitrag wurde in unseren ausführlichen Artikel zum Altersvorsorgedepot integriert."
        />
        <meta httpEquiv="refresh" content={`3; url=${TARGET}`} />
      </Helmet>
      <Header />
      <main className="mx-auto max-w-2xl px-4 py-24 text-center">
        <h1 className="text-3xl font-semibold mb-4">Dieser Artikel ist umgezogen</h1>
        <p className="text-lg text-muted-foreground mb-6">
          Dieser Beitrag wurde in unseren ausführlichen Artikel zum Altersvorsorgedepot
          integriert. Sie werden in wenigen Sekunden weitergeleitet.
        </p>
        <p>
          <Link to={TARGET} className="text-primary underline underline-offset-4">
            Zum Artikel: Altersvorsorgedepot — der Riester-Nachfolger ab 2027
          </Link>
        </p>
      </main>
      <Footer />
    </>
  );
}
